import { render, staticRenderFns } from "./measurement.vue?vue&type=template&id=ec50c07a&scoped=true"
import script from "./measurement.vue?vue&type=script&lang=js"
export * from "./measurement.vue?vue&type=script&lang=js"
import style0 from "./measurement.vue?vue&type=style&index=0&id=ec50c07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec50c07a",
  null
  
)

export default component.exports